import {OrganizationJsonLd} from 'next-seo';
import {useUnloggedData} from '@app/modules/ssg-data/unlogged-data';
import ogDeezerLogo from '@images/common/logo-deezer-og.png';
import {useRouter} from 'next/router';
import {getCurrentUrl} from '@app/modules/location';
import type {FunctionComponent} from 'react';

export const OrganizationStructuredData: FunctionComponent = () => {
	const {locale} = useRouter();
	const [{socialLinks}] = useUnloggedData();

	return (
		<OrganizationJsonLd
			name="Deezer"
			url={getCurrentUrl({locale, pathname: '/'})}
			logo={ogDeezerLogo.src}
			sameAs={(socialLinks || []).map((link) => link.url)}
			contactPoint={[
				{
					'@type': 'ContactPoint',
					telephone: '+33-1-84-25-25-00',
					contactType: 'customer support',
					areaServed: 'FR',
					availableLanguage: ['French', 'English'],
				},
			]}
			foundingDate="2007"
			founder={{
				'@type': 'Person',
				name: 'Daniel Marhely',
			}}
			address={{
				'@type': 'PostalAddress',
				streetAddress: '24 rue de Calais',
				addressLocality: 'Paris',
				postalCode: '75009',
				addressCountry: 'FR',
			}}
		/>
	);
};
